/** JWT auth helpers — stores access/refresh alongside existing persona IDs. */

const ACCESS_KEY = "accessToken";
const REFRESH_KEY = "refreshToken";

/** Normalize Indian mobile to 10 digits. */
export function normalizeMobileNo(value) {
  let digits = String(value || "").replace(/\D/g, "");
  if (digits.length > 10 && digits.startsWith("91")) {
    digits = digits.slice(-10);
  } else if (digits.length === 11 && digits.startsWith("0")) {
    digits = digits.slice(1);
  }
  return digits;
}

/** Build trainee sign-in body for email or mobile + password. */
export function buildTraineeSignInPayload(login, password) {
  const identifier = String(login || "").trim();
  if (identifier.includes("@")) {
    return { email: identifier, password };
  }
  return { mobile_no: identifier, password };
}

/** Build OTP login request body (mobile). */
export function buildTraineeOtpLoginRequestPayload(mobileNo) {
  const mobile_no = normalizeMobileNo(mobileNo);
  return { mobile_no, contactNo: mobile_no };
}

/** Build OTP login verify body. */
export function buildTraineeOtpLoginVerifyPayload(mobileNo, otp) {
  const mobile_no = normalizeMobileNo(mobileNo);
  return { mobile_no, contactNo: mobile_no, otp: String(otp || "").trim() };
}

export function storeTokens(data) {
  if (data?.access) {
    localStorage.setItem(ACCESS_KEY, data.access);
  }
  if (data?.refresh) {
    localStorage.setItem(REFRESH_KEY, data.refresh);
  }
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_KEY);
}

export function clearTokens() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}

/** Clear JWT + all persona identity keys used across the app. */
export function clearAuthSession() {
  clearTokens();
  localStorage.removeItem("userId");
  localStorage.removeItem("traineeId");
  localStorage.removeItem("trainerId");
  localStorage.removeItem("role");
  localStorage.removeItem("email");
  localStorage.removeItem("status");
  localStorage.removeItem("company_id");
  localStorage.removeItem("companyId");
}

export function isAuthenticated() {
  return Boolean(getAccessToken());
}

/** True when any portal user (trainee, trainer, employer, institution) is signed in. */
export function isPortalUserLoggedIn() {
  const hasPersona = ["traineeId", "trainerId", "userId"].some((key) =>
    Boolean(localStorage.getItem(key))
  );
  return hasPersona && isAuthenticated();
}
